import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-list-subscription-license-rights',
  templateUrl: './list-subscription-license-rights.component.html',
  styleUrls: ['./list-subscription-license-rights.component.css']
})
export class ListSubscriptionLicenseRightsComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  companyID = 0;
  selectedCompany: any = '';
  currentUser;
  getCompanyobj: any = [];
  categoryObj: any = [];
  webCatTotal: number = 0;
  slCatPage = 1;
  slCatLimit = 10;
  slCatSkip = 0;
  slCatord = "asc";
  slCatColname = "orderno";
  constructor(private clientService: ClientService,
    private masterService: MasterService) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;
      this.selectedCompany = this.companyID;
      this.getRightsList();
    }
    if (this.currentUser.admin_customer_id == '0') this.getCompany();
  }
  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      const working = this.bindWorkingCompany(this.getCompanyobj);
      if (working) {
        this.selectedCompany = working;
        this.getRightsList();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }
  onCompanyChange(value?: any) {
    if (value !== undefined) {
      this.selectedCompany = value;
    }
    this.slCatPage = 1;
    this.getRightsList();
  }
  resetFilters() {
    this.slCatPage = 1;
    this.slCatSkip = 0;
    if (this.searchText && this.searchText.nativeElement) {
      this.searchText.nativeElement.value = '';
    }
    if (this.companyID == 0) {
      this.selectedCompany = this.bindWorkingCompany(this.getCompanyobj) || '';
    }
    this.getRightsList();
  }
  getRightsList() {
    let searchTerm = this.searchText.nativeElement.value;
    this.slCatSkip = (this.slCatPage - 1) * this.slCatLimit;
    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();
      this.masterService.getSubscriptionLicenseRightsList(this.selectedCompany, this.slCatLimit, this.slCatSkip, searchTerm, this.slCatColname, this.slCatord).subscribe(data => {
        this.ngxSpinnerService.hide();
        if (data.status) {
          if (data.data.rows == null) { this.categoryObj = [] }
          else { this.categoryObj = data.data.rows }
          this.webCatTotal = data.data.total;
        } else {
          this.categoryObj = [];
          this.webCatTotal = 0;
        }
      }, error => { console.log(error); this.ngxSpinnerService.hide(); });
    } else {
      this.categoryObj = [];
      this.webCatTotal = 0;
      this.ngxSpinnerService.hide();
    }
  }
  setOrder(value: string) {
    this.slCatColname = value
    if (this.slCatord == 'asc') {
      this.slCatord = 'desc'
    } else {
      this.slCatord = 'asc'
    }
    this.getRightsList()
  }
  editPost(id: any) {
    localStorage.setItem("edit_subscription_license_rights_id", id);
    localStorage.setItem("edit_subscription_license_rights_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/edit-subscription-license-rights']);
  }
  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    this.ngxSpinnerService.show();
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.slCatSkip = 0;
          this.slCatPage = 1;
        }),
        switchMap(data => this.masterService.getSubscriptionLicenseRightsList(this.selectedCompany, this.slCatLimit, this.slCatSkip, this.searchText.nativeElement.value, this.slCatColname, this.slCatord))
      )
      .subscribe((res: any) => {
        if (res.status) {
          if (res.data.rows == null) { this.categoryObj = [] }
          else { this.categoryObj = res.data.rows }
          this.webCatTotal = res.data.total;
        } else {
          this.categoryObj = [];
          this.webCatTotal = 0;
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.categoryObj = [];
        this.webCatTotal = 0;
        this.ngxSpinnerService.hide();
      });
  }
}
